import { z } from "zod";

const ulid = z
  .string()
  .regex(/^[0-9A-HJKMNP-TV-Z]{26}$/)
  .optional()
  .catch(undefined);

/** Anúncios e pedidos do marketplace: conta escolhida. */
export const marketplaceSearch = z.object({ conta: ulid });

/** Volta do OAuth (redirect_uri): `code` e `state` do Mercado Livre; `error` quando o usuário recusa. */
export const mlCallbackSearch = z.object({
  code: z.string().max(256).optional().catch(undefined),
  state: z.string().max(64).optional().catch(undefined),
  error: z.string().max(100).optional().catch(undefined),
});

/** Consentimento do Mercado Livre de testes. */
export const mlSandboxSearch = z.object({ state: z.string().max(64).optional().catch(undefined) });

/** Volta da autorização da Shopee: `code` e `shop_id` (da Shopee) e o `state` que o ERP pôs na URL de retorno. */
export const shopeeCallbackSearch = z.object({
  code: z.string().max(128).optional().catch(undefined),
  shop_id: z.string().max(20).optional().catch(undefined),
  state: z.string().max(64).optional().catch(undefined),
  error: z.string().max(100).optional().catch(undefined),
});

/** Consentimento da Shopee de testes. */
export const shopeeSandboxSearch = mlSandboxSearch;
